/* eslint-disable no-constant-condition */
import React, { useState } from 'react'
import { Spacer, Button } from '@cleartrip/bento'
import Field from '../../../components/Form'
import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'

import { sendOtpForSignIn } from '../../../pages/Trips/trips.helper'
import { errorConfig } from './errorConfig'

function SignInBlockML({
  validateEmailHandler,

  email,
  setEmail,

  setPageName,

  setIsGOpaque = () => { },
  setIsPOpaque = () => { },
  setIsEmailEditable = () => { },
  setIsMOpaque = () => { },
  isEmailEditable
}) {
  const [apiError, setApiError] = useState('')

  const handleCancel = () => {
    setIsEmailEditable(true)
    setIsGOpaque(false)
    setIsPOpaque(false)
    setIsMOpaque(false)
  }
  const emailChangeHandler = e => {
    setApiError('')
    const val = e.target.value
    setEmail(val)
  }
  const sendOtp = async () => {
    setApiError('')
    const validateEmail = validateEmailHandler()

    try {
      if (validateEmail) {
        const payload = {
          type: 'EMAIL',
          value: email,
          action: 'UPDATE_EMAIL'
        }
        const res = await sendOtpForSignIn(payload)
        const { status, error } = res || {}
        if (status === 202) {
          setPageName(USER_PROFILE_PAGE_CONTANTS.VERIFY_EMAILML)
        } else {
          const { response = { data: {} } } = error || {}
          const { data = {} } = response
          const { message } = data
          const err = errorConfig[message] || errorConfig.default
          setApiError(err)
        }
      } else {
        setApiError('Please enter a valid email !')
      }
    } catch (e) {
      setApiError('Something went wrong !')
      console.error('otp api error', e)
    }
  }

  return (
    <div className="flex flex-column">
      <span className=" fw-400 fs-16 mt-6 mb-5">Add email address</span>

      {/* <Input
        type="text"
        placeholder="Email address"
        inputClassName="fs-14 lh-18 color-neutral-900 input-border input-neutral-border h-56"
        wrapperClassName=" br h-36 flex flex-middle"
        value={email}
        maxLimit={32}
        onChange={e => setEmail(e)}
      /> */}

      <Field
        label="Email address"
        wrapperClassName="w-328 br-6-imp"
        type="text"
        value={email}
        maxLimit={32}
        onChange={e => emailChangeHandler(e)}
      />
      {apiError && (
        <div className="fw-500 fs-12 lh-16 mt-2" style={{ color: '#CC1414' }}>
          {apiError}
        </div>
      )}
      <div className="flex flex-column">
        <Spacer className="mt-6" />

        <div className="flex flex-row">
          <Button
            className="h-10 w-170 br-6-imp"
            disabled={false}
            size="lg"
            type="secondary"
            busy={false}
            onClick={() => sendOtp()}
          >
            <span className={`${false ? 'c-grey-30' : ''} fs-3 fw-500 `}>
              Confirm and verify
            </span>
          </Button>

          <a
            onClick={() => handleCancel()}
            className="fw-600 fs-14 lh-20 ml-12 mt-2"
          >
            Cancel
          </a>
        </div>
        <Spacer className="mt-5" />
      </div>
    </div>
  )
}

export default SignInBlockML
